import React from 'react';
import SpecBottomSheet from '../SpecBottomSheet/SpecBottomSheet';
import { UserCircleIcon, UserGroupIcon, LocationMarkerIcon, PlusCircleIcon, UserRemoveIcon } from '../icons';
import { UserType } from '../UserTag/UserTag';
import './UserTypeInfo.css';

export interface UserTypeInfoProps {
  type: UserType;
  open: boolean;
  onClose: () => void;
}

const USER_TYPE_INFO = {
  musician: {
    title: 'Musician Accounts',
    description: 'Musicians can create bands, be added to bands, display photos from past shows, and add comments and photos to shows.',
    icon: UserCircleIcon,
    className: 'user-type-info-musician',
  },
  fan: {
    title: 'Fan Accounts',
    description: 'Fan accounts can add comments and photos to shows, all saved to their profile.',
    icon: UserCircleIcon,
    className: 'user-type-info-fan',
  },
  band: {
    title: 'Band Accounts',
    description: 'Bands can add shows, add musicians who play with the band, display photos and comments from past shows.',
    icon: UserGroupIcon,
    className: 'user-type-info-band',
  },
  venue: {
    title: 'Venue Accounts',
    description: 'Venue accounts display photos and comments from past shows, list upcoming shows, and where current show photos can be added.',
    icon: LocationMarkerIcon,
    className: 'user-type-info-venue',
  },
  showContributor: {
    title: 'Show Contributor',
    description: 'Show Contributors of a band can add or edit shows on Spec. They help keep this whole thing going.',
    icon: PlusCircleIcon,
    className: 'user-type-info-show-contributor',
  },
  bandMember: {
    title: 'Band Member',
    description: 'Band members of a band are musicians who will show up on the band roster, and have show comments and photos from those bands shows saved to their profile.',
    icon: UserGroupIcon,
    className: 'user-type-info-band-member',
  },
  noAccount: {
    title: 'No User Account',
    description: 'This was added by a user not logged in to a Spec account. Contact us to report.',
    icon: UserRemoveIcon,
    className: 'user-type-info-no-account',
  },
};

export const UserTypeInfo: React.FC<UserTypeInfoProps> = ({ type, open, onClose }) => {
  const info = USER_TYPE_INFO[type];
  const IconComponent = info.icon;

  return (
    <SpecBottomSheet open={open} onClose={onClose} showHandle={false}>
      <div className={`user-type-info-content ${info.className}`}>
        <div className="user-type-info-header">
          <IconComponent size="m" color="currentColor" />
          <h3 className="user-type-info-title">{info.title}</h3>
        </div>
        <p className="user-type-info-description">{info.description}</p>
      </div>
    </SpecBottomSheet>
  );
};

export default UserTypeInfo;
